var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClubsparties(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 21v-2h5v-5L3 5V3h18v2l-8 9v5h5v2H6zM7.45 7h9.1l1.8-2H5.65l1.8 2zM12 12.1L14.775 9h-5.55L12 12.1z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubsparties);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNNiAyMVYxOUgxMVYxNEwzIDVWM0gyMVY1TDEzIDE0VjE5SDE4VjIxSDZaTTcuNDUgN0gxNi41NUwxOC4zNSA1SDUuNjVMNy40NSA3Wk0xMiAxMi4xTDE0Ljc3NSA5SDkuMjI1TDEyIDEyLjFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+";
export { ForwardRef as ReactComponent };